export const navItems = [
  { to: '/tableau', label: 'Tableau', icon: '▤' },
  { to: '/a-decider', label: 'À décider', icon: '✓' },
  { to: '/ma-journee', label: 'Ma journée', icon: '☼' },
  { to: '/fil', label: 'Fil', icon: '≡' },
  { to: '/agenda', label: 'Agenda', icon: '▣' },
  { to: '/personnes', label: 'Personnes', icon: '◎' },
] as const;
